import * as fromDatatype from '../datatype-library/index';

export interface bl_catalog_login_subject_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_login_guid: fromDatatype.GuidDataFieldInterface;
  applet_catalog_guid: fromDatatype.GuidDataFieldInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
}

export class bl_catalog_login_subject_link_RowClass
  implements bl_catalog_login_subject_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    app_login_guid: fromDatatype.GuidDataFieldInterface;
    applet_catalog_guid: fromDatatype.GuidDataFieldInterface;
    rank: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
}
